// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { ClientProfileWithRelationshipsFragment, ClientProfileBasicFragment } from '../../graphql/ClientProfile.generated';
import { gql } from '@apollo/client';
import { ClientProfileWithRelationshipsFragmentDoc, ClientProfileBasicFragmentDoc } from '../../graphql/ClientProfile.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type BeneficiaryFormDataQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.HouseholdWhereInput>;
}>;


export type BeneficiaryFormDataQuery = { __typename?: 'Query', households: { __typename?: 'HouseholdConnection', edges?: Array<{ __typename?: 'HouseholdEdge', node?: { __typename?: 'Household', id: string, clientProfiles?: Array<(
          { __typename?: 'ClientProfile' }
          & ClientProfileWithRelationshipsFragment
        )> | null, possiblePrimaryClients: Array<(
          { __typename?: 'ClientProfile' }
          & ClientProfileBasicFragment
        )> } | null } | null> | null } };

export const Operations = {
  Query: {
    BeneficiaryFormData: 'BeneficiaryFormData' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const BeneficiaryFormDataDocument = gql`
    query BeneficiaryFormData($where: HouseholdWhereInput) {
  households(where: $where) {
    edges {
      node {
        id
        clientProfiles {
          ...ClientProfileWithRelationships
        }
        possiblePrimaryClients {
          ...ClientProfileBasic
        }
      }
    }
  }
}
    ${ClientProfileWithRelationshipsFragmentDoc}
${ClientProfileBasicFragmentDoc}`;

/**
 * __useBeneficiaryFormDataQuery__
 *
 * To run a query within a React component, call `useBeneficiaryFormDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useBeneficiaryFormDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBeneficiaryFormDataQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useBeneficiaryFormDataQuery(baseOptions?: Apollo.QueryHookOptions<BeneficiaryFormDataQuery, BeneficiaryFormDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BeneficiaryFormDataQuery, BeneficiaryFormDataQueryVariables>(BeneficiaryFormDataDocument, withFetchPolicyContext(options));
      }
export function useBeneficiaryFormDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BeneficiaryFormDataQuery, BeneficiaryFormDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BeneficiaryFormDataQuery, BeneficiaryFormDataQueryVariables>(BeneficiaryFormDataDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useBeneficiaryFormDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BeneficiaryFormDataQuery, BeneficiaryFormDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BeneficiaryFormDataQuery, BeneficiaryFormDataQueryVariables>(BeneficiaryFormDataDocument, withFetchPolicyContext(options));
        }
export type BeneficiaryFormDataQueryHookResult = ReturnType<typeof useBeneficiaryFormDataQuery>;
export type BeneficiaryFormDataLazyQueryHookResult = ReturnType<typeof useBeneficiaryFormDataLazyQuery>;
export type BeneficiaryFormDataSuspenseQueryHookResult = ReturnType<typeof useBeneficiaryFormDataSuspenseQuery>;
export type BeneficiaryFormDataQueryResult = Apollo.QueryResult<BeneficiaryFormDataQuery, BeneficiaryFormDataQueryVariables>;